function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5742 1.75741C18.2079 1.35256 17.5714 1.3546 17.2077 1.7618L1.85395 18.9508C1.43469 19.4202 1.60077 20.1626 2.18005 20.4086L16.9076 26.6626C17.3954 26.8697 17.828 26.2752 17.4808 25.8748L16.3076 24.5219C16.2078 24.4068 16.0831 24.3161 15.9429 24.2566L5.36358 19.764C4.73309 19.4963 4.55234 18.6883 5.00865 18.1774L17.1564 4.57771C17.5522 4.13452 18.245 4.13229 18.6437 4.57294L25.5987 12.2594C25.8184 12.5023 25.9053 12.8374 25.8313 13.1565L25.6045 14.1333C25.4731 14.6996 25.903 15.2408 26.4844 15.2408C26.8967 15.2408 27.2567 14.9616 27.3593 14.5622L27.8536 12.6368C27.9335 12.3359 27.8558 12.0151 27.6469 11.7843L18.5742 1.75741Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0797 24.2654L24.33 30.3198C24.4964 30.5117 24.7915 30.5204 24.9689 30.3385L30.8755 24.2841C31.1439 24.009 30.9489 23.5466 30.5646 23.5466H28.0738C27.834 23.5466 27.6396 23.3522 27.6396 23.1123V17.9753C27.6396 17.7342 27.4431 17.5392 27.202 17.541L22.7517 17.5745C22.5131 17.5763 22.3207 17.7702 22.3207 18.0087V23.1123C22.3207 23.3522 22.1262 23.5466 21.8864 23.5466H19.4078C19.0356 23.5466 18.8358 23.9842 19.0797 24.2654Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.0002 13.3914V14.5004C24.0002 14.7766 23.7763 15.0004 23.5002 15.0004H21.5002C20.9479 15.0004 20.5002 15.4482 20.5002 16.0004V20.5004C20.5002 21.0527 20.0524 21.5004 19.5002 21.5004H18.3029C18.1055 21.5004 17.9125 21.5589 17.7482 21.6684L16.9475 22.2022C16.6682 22.3884 16.3141 22.4221 16.0047 22.2918L8.30853 19.0513C7.67103 18.7829 7.49203 17.9639 7.95943 17.454L17.2656 7.30182C17.661 6.87047 18.3406 6.86929 18.7375 7.29926L23.735 12.7131C23.9055 12.8979 24.0002 13.14 24.0002 13.3914Z",
  fill: "white"
});

function SvgExportVrs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportVrs);
export default __webpack_public_path__ + "static/media/ExportVRS.8710aa3a.svg";
export { ForwardRef as ReactComponent };